
export const OrderService = {};

export default OrderService;